import dayjs from 'dayjs';

const ageInRange = (
  firstSessionDate: string | null,
  childDateOfBirth?: string | Date | null,
  ageMonthsStart?: number,
  ageMonthsEnd?: number,
): boolean | undefined => {
  // Checks how old child will be on the first session
  const sessionDate = dayjs(firstSessionDate);
  const formattedBirthday = dayjs(childDateOfBirth);

  const ageInMonths = sessionDate.diff(formattedBirthday, 'month');

  if (ageMonthsStart === undefined || ageMonthsEnd === undefined) {
    return;
  }

  if (
    (ageInMonths > ageMonthsStart && ageInMonths < ageMonthsEnd) ||
    ageInMonths === ageMonthsStart ||
    ageInMonths === ageMonthsEnd
  ) {
    return true;
  }
  return false;
};

export default ageInRange;
